/* --eslint-disable */

const maarayksetRows = [
  { label: 'Aktiivinen suojaus', isHeader: true },
  { label: 'Sprinklaus', func: 'solveSprinklaus' },
  { label: 'Sähköverkkoon kytketty palovaroitin', func: 'solvePalovaroitin' },
  { label: 'Paloilmoitin', func: 'solvePaloilmoitin' },
  { label: 'Hätäkeskukseen kytketty paloilmoitin', func: 'solveHKPaloilmoitin' },
  { label: 'Laajuus', isHeader: true },
  { label: 'Palo-osaston koko kellarissa', p3: {e: '≤ 400 m<sup>2</sup>', s: '≤ 1200 m<sup>2</sup>'}, p2: {e: '≤ 800 m<sup>2</sup>', s: '≤ 2400 m<sup>2</sup>'}, p1: {e: '≤ 800 m<sup>2</sup>', s: '≤ 2400 m<sup>2</sup>'} },
  { label: 'Palo-osaston koko ullakolla / yläpohjan ontelossa', value: '≤ 1600 m<sup>2</sup>', p3: 'Alapuolisten osastojen mukaan' },
  { label: 'Kerroksen palo-osaston jako osiin', func: 'solvePalosastoJako' },
  { label: 'Ullakon / yläpohjan ontelon palo-osaston jako osiin', value: 'Osan koko ≤ 400 m<sup>2</sup>' },
  { label: 'Tuulettuvan alapohjan ontelon jako osiin ', value: 'Osan koko ≤ 800 m<sup>2</sup><br/>Ei jakoa, jos pinnat D-s2, d2 tai alapohja REI 60' },
  { label: 'Rakennusosien luokka', isHeader: true },
  { label: 'Kantavan rungon rakennustarvikkeet', func: 'solveKantavanRungonRakennustarvikkeet' },
  { label: 'Kantavan ulkoseinän rungon rakennustarvikkeet', value: 'D-s2, d2', p1: 'A2-s1, d0' },
  { label: 'Ei-kantavan ulkoseinän rungon rakennustarvikkeet', value: 'D-s2, d2' },
  { label: 'Lämmöneristeet ulkoseinässä', value: '-', p2: { ks2: 'A2-s1, d0', default: '-' }, p1: 'B-s1, d0 (<a href="#viitteet">ks. viite 6</a>)<br/> Eristävältä osaltaan' },
  { label: 'Lämmöneristeet yläpohjassa', value: '-', p2: { ks2: 'A2-s1, d0', default: '-' }, p1: 'B-s1, d0 (<a href="#viitteet">ks. viite 6</a>)<br/> Eristävältä osaltaan' },
  { label: 'Onteloiden täytteet', value: '-', p2: { ks2: 'A2-s1, d0', default: '-' } },
  { label: 'Kantavat rakennusosat kerroksessa', p3: '-', p2: { v: 'runko', rs: 'X' }, p1: { v: 'runko', rs: 'X' } },
  { label: 'Kantavat rakennusosat kellarissa (ylin kellarikerros) ', p3: '-', p2: 'R 60, A2', p1: { v: 'runko', rs: 'X, A2' } },
  { label: 'Porrastasanteet ja -syöksyt uloskäytävässä', p3: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'R 30' }, p2: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'R 30' }, p1: 'R 30' },
  { label: 'Kantavat rakenteet parvekkeessa', p3: '-', p2: { r30: 'R 15', r45: 'R 30', default: 'R 30' }, p1: { r90: 'R 45', default: 'R 30' } },
  { label: 'Osastoivat rakennusosat kerroksessa', value: 'EI 30 (myös R 30)', p2: { ks2: 'EI 60 (myös R 60) (<a href="#ehdot-f">ks. ehdot F</a>)', default: 'EI 30 (myös R 30)' }, p1: { r90: 'EI 90 (myös R 90)', default: 'EI 60 (myös R 60)' } },
  { label: 'Osiin jakavat rakennusosat kerroksissa', value: { ids: [9, 10], idvalue: 'EI 15 (myös R 15)', default: '-' }, p1: '-' },
  { label: 'Osastoivat rakennusosat kellarissa (ylin kellarikerros)',
    p3: { ids: [5, 6], idvalue: 'EI 30 (myös R 30)<br/>(Kellari kuuluu yhdelle asunnolle)', default: 'EI 30, A2 (myös R 30)' },
    p2: 'EI 60, A2 (myös R 60)',
    p1: { r90: 'EI 90, A2 (myös R 90)', default: 'EI 60, A2 (myös R 60)' } },
  { label: 'Osastoiva rakennusosa kellarin ja kerroksen välillä',
    p3: { ids: [5, 6], idvalue: 'EI 30 (myös R 30)<br/>(Kellari kuuluu yhdelle asunnolle)', default: 'EI 30, A2 (myös R 30)' },
    p2: 'EI 60, A2 (myös R 60)',
    p1: { r90: 'EI 90, A2 (myös R 90)', default: 'EI 60, A2 (myös R 60)' } },
  { label: 'Osastoivat rakennusosat ullakolla / yläpohjan ontelossa', value: 'EI 30 (myös R 30)' },
  { label: 'Osiin jakavat rakennusosat ullakolla / yläpohjan ja alapohjan ontelossa', value: 'EI 15 (myös R 15)' },
  { label: 'Osastoiva rakennusosa ullakon / yläpohjan ontelon ja kerroksen välillä', p3: '-', p2: { ks2: 'EI 60 (myös R 60) (<a href="#ehdot-f">ks. ehdot F</a>)', default: 'EI 30 (myös R 30)' }, p1: { r90: 'EI 90 (myös R 90)', default: 'EI 60 (myös R 60)' } },
  { label: 'Osastoiva rakennusosa alapohjan ontelon ja kerroksen välillä<br/>(<a href="#viitteet">ks. viite 1</a>)', p3: 'EI 30 (myös R 30)', p2: { ks2: 'EI 60 (myös R 60) (<a href="#ehdot-f">ks. ehdot F</a>)', default: 'EI 30 (myös R 30)' }, p1: { r90: 'EI 90 (myös R 90)', default: 'EI 60 (myös R 60)' } },
  { label: 'Parvekelaatan osastoivuus parvekkeessa', value: '-' },
  { label: 'Parvekelaatan osastoivuus lasitetussa parvekkeessa', value: '-', p2: { ks2: 'EI 30', default: '-' } }, // ID poikkeus puuttuu P2
  { label: 'Pintaluokka', isHeader: true }, // index 32
  { label: 'Seinä- ja kattopinnat kerroksessa', func: 'solvePinnatKerroksessa' },
  { label: 'Seinä- ja kattopinnat kellarissa', p3: 'D-s2, d2', p2: 'B-s1, d0', p1: 'C-s2, d1' },
  { label: 'Seinä- ja kattopinnat saunassa ja kylpyhuoneessa', value: 'D-s2, d2' },
  { label: 'Seinä- ja kattopinnat uloskäytävässä', p3: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'B-s1, d0'}, value: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'A2-s1, d0<br/>Vähäiset osat B-s1, d0' } },
  { label: 'Seinäpinnat ja seinämäiset pinnat parvekkeissa', isDynamic: true, func: 'solvePinnat' },
  { label: 'Kattopinnat (parvekelaattojen alapinnat) parvekkeissa', isDynamic: true, func: 'solvePinnat' },
  { label: 'Pilarit parvekkeissa', isDynamic: true, func: 'solvePinnat' },
  { label: 'Palkit parvekkeissa', isDynamic: true, func: 'solvePinnat' },
  { label: 'Lattiapinnat kerroksessa', value: {ids: [3, 4, 10], idvalue: 'D<sub>FL</sub>-s1', default: '-'}, p3: '-' }, // JATKA TÄSTÄ
  { label: 'Lattiapinnat kellarissa', value: 'D<sub>FL</sub>-s1' },
  { label: 'Lattiapinnat saunassa ja kylpyhuoneessa', value: '-' },
  { label: 'Lattiapinnat uloskäytävässä', value: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'D<sub>FL</sub>-s1' } },
  { label: 'Lattiapinnat parvekkeissa', isDynamic: true, value: '-' },
  { label: 'Porrastasanteet ja -syöksyt uloskäytävässä', p3: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'B-s1, d0' }, p2: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'A2-s1, d0<br/>Vähäiset osat B-s1, d0' }, p1: 'A2-s1, d0<br/>Vähäiset osat B-s1, d0' },
  { label: 'Porrasaskelmien yläpinnat uloskäytävässä', value: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'D<sub>FL</sub>-s1' } },
  { label: 'Porrastasanteiden yläpinnat uloskäytävässä', value: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'D<sub>FL</sub>-s1' } },
  { label: 'Porrasaskelmien etupinnat uloskäytävässä', value: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'B-s1, d0' } },
  { label: 'Porrastasanteiden etupinnat uloskäytävässä', value: { ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: 'B-s1, d0' } },
  { label: 'Ulkoverhouksen ulkopinta', func: 'solveUlkoverhous' },
  { label: 'Tuuletetun ulkoverhouksen taustapinta', func: 'solveUlkoverhous' },
  { label: 'Ulkoverhouksen kiinnityskoolaus', value: 'D-s2, d2<br/>(<a href="#viitteet">ks. viite 9</a>)', p3: 'D-s2, d2' },
  { label: 'Ulkoseinän tuulensuojan / lämmöneristeen ulkopinta ', func: 'solveTuulensuoja' },
  { label: 'Ullakon / yläpohjan ontelon pinnat, kun osastoitu alapuolisesta tilasta', p3: '-<br/>(Osastointia ei vaadita)', value: 'D-s2, d2<br/>(E-luokan aluskate mahdollinen)' },
  { label: 'Vesikatteen ulkopinta', value: 'B<sub>ROOF</sub>(t2)' },
  { label: 'Sisäpuolinen suojaverhous', isHeader: true },
  { label: 'Seinä- ja kattopinnat kerroksessa', value: '-', p2: {ks3: 'K<sub>2</sub> 10, A2-s1, d0 (<a href="#ehdot-f">ks. ehdot F</a>)', ks2: 'K<sub>2</sub> 30, A2-s1, d0 (<a href="#ehdot-f">ks. ehdot F</a>)', default: 'K<sub>2</sub> 10, B-s1, d0 (<a href="#ehdot-e">ks. ehdot E</a>)'} },
  { label: 'Seinä- ja kattopinnat saunassa ja kylpyhuoneessa', value: '-', p2: {ks3: 'K<sub>2</sub> 10, A2-s1, d0 (<a href="#ehdot-f">ks. ehdot F</a>)', ks2: 'K<sub>2</sub> 30, A2-s1, d0 (<a href="#ehdot-f">ks. ehdot F</a>)', default: 'K<sub>2</sub> 10, B-s1, d0 (<a href="#ehdot-e">ks. ehdot E</a>)'} },
  { label: 'Seinä- ja kattopinnat uloskäytävässä', value: '-', p2: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: {ks2: 'K<sub>2</sub> 10, A2-s1, d0', default: 'K<sub>2</sub> 10, B-s1, d0 (<a href="#ehdot-e">ks. ehdot E</a>)'}} },
  { label: 'Lattiapinnat kerroksessa', value: '-', p2: {ks3: 'K<sub>2</sub> 10, A2-s1, d0 (<a href="#ehdot-f">ks. ehdot F</a>)<br/>Lattiapinnoite pintaluokan mukaan', ks2: 'K<sub>2</sub> 30, A2-s1, d0<br/>Lattiapinnoite pintaluokan mukaan', default: '-'} },
  { label: 'Lattiapinnat saunassa ja kylpyhuoneessa', value: '-', p2: {ks3: 'K<sub>2</sub> 10, A2-s1, d0 (<a href="#ehdot-f">ks. ehdot F</a>)<br/>Lattiapinnoite pintaluokan mukaan', ks2: 'K<sub>2</sub> 30, A2-s1, d0<br/>Lattiapinnoite pintaluokan mukaan', default: '-'} },
  { label: 'Lattiapinnat uloskäytävässä', value: '-', p2: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: {ks2: 'K<sub>2</sub> 10, A2-s1, d0<br/>Lattiapinnoite pintaluokan mukaan', default: '-'}} },
  { label: 'Porrastasanteet ja -syöksyt uloskäytävässä', value: '-', p2: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: {ks2: 'K<sub>2</sub> 10, A2-s1, d0<br/>Ei koske vähäisiä B-s1, d0-osia', default: '-'}} },
  { label: 'Porrasaskelmien yläpinnat uloskäytävässä', value: '-', p2: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: '-'} },
  { label: 'Porrastasanteiden yläpinnat uloskäytävässä', value: '-', p2: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: '-'} },
  { label: 'Porrasaskelmien etupinnat uloskäytävässä', value: '-', p2: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: '-'} },
  { label: 'Porrastasanteiden etupinnat uloskäytävässä', value: '-', p2: {ids: [5, 6], idvalue: '- <br/> Ei uloskäytävää', default: '-'} },
  { label: 'Ulkopuolinen suojaverhous', isHeader: true },
  { label: 'Seinä- ja kattopinnat varatieparvekkeessa', value: '-' },
  { label: 'Lattiapinta varatieparvekkeessa', value: '-' },
  { label: 'Ulkoseinän rungon ulkopinta', value: '-', p2: {ids: [5, 6], idvalue: '-', default: {ks2: 'K<sub>2</sub> 10, A2-s1, d0', default: '-'}} },
  // Jos autosuoja rakennuksen osana
  { label: 'Autosuoja rakennuksen osana', isHeader: true, condition: 'aro' },
  { label: 'Palo-osasto (sijainti vain 1. kerroksessa)', value: {e: '≤ 3000 m<sup>2</sup> (ks. viitteet 10 ja 11)', s: '≤ 24000 m<sup>2</sup>'}, p2: '≤ 3000 m<sup>2</sup>', p3: {e: '≤ 400 m<sup>2</sup>', s: '≤ 3000 m<sup>2</sup>'}, condition: 'aro' },
  { label: 'Kantavat rakennusosat (sijainti vain 1. kerroksessa)', value: 'R 60, A2', p2: {default: 'R 60', ks2: 'R 60, A2'}, p3: '-', condition: 'aro' },
  { label: 'Osastoivat rakennusosat (sijainti vain 1. kerroksessa)', value: 'EI 60, A2', p2: {default: 'EI 60', ks2: 'EI 60, A2'}, p3: 'EI 30 (myös R 30)', condition: 'aro' },
  { label: 'Palo-osasto (sijainti kellarissa)', value: {e: '≤ 1500 m<sup>2</sup> (ks. viite 11)', s: '≤ 10000 m<sup>2</sup>'}, p2: {e: '≤ 400 m<sup>2</sup>', s: '≤ 3000 m<sup>2</sup>'}, p3: '≤ 60 m<sup>2</sup>', condition: 'aro' },
  { label: 'Kantavat rakennusosat (sijainti kellarissa)', value: 'R 60, A2', p2: 'R 60, A2', p3: '-', condition: 'aro' },
  { label: 'Osastoivat rakennusosat (sijainti kellarissa)', value: 'EI 60, A2', p2: 'EI 60, A2', p3: 'EI 30, A2 (myös R 30)', condition: 'aro' },
  // Jos myymälä rakennuksen osana
  { label: 'Myymälä rakennuksen osana', isHeader: true, condition: 'mro' },
  { label: 'Palo-osasto (< 600 MJ/m<sup>2</sup>, sijainti vapaa)', value: '≤ 300 m<sup>2</sup>', p2: {default: {e: '≤ 2400 m<sup>2</sup>', s: '≤ 9600 m<sup>2</sup>'}, ks2: '≤ 300 m<sup>2</sup>'}, p3: '≤ 400 m<sup>2</sup>', condition: 'mro' },
  { label: 'Kantavat rakennusosat (< 600 MJ/m<sup>2</sup>, sijainti vapaa)', value: 'R 60', p2: {default: 'R 30', ks2: 'R 60'}, p3: '-', condition: 'mro' },
  { label: 'Osastoivat rakennusosat (< 600 MJ/m<sup>2</sup>, sijainti vapaa)', value: 'EI 60', p2: {default: 'EI 30', ks2: 'EI 60'}, p3: 'EI 30 (myös R 30)', condition: 'mro' },
  { label: 'Palo-osasto (600 - 1200 MJ/m<sup>2</sup>, sijainti vain 1. kerroksessa)', value: {e: '≤ 2400 m<sup>2</sup>', s: '≤ 24000 m<sup>2</sup>'}, p2: {default: {e: '≤ 2400 m<sup>2</sup>', s: '≤ 9600 m<sup>2</sup>'}, ks2: '>300...≤ 1200 m<sup>2</sup>'}, p3: {e: '≤ 400 m<sup>2</sup>', s: '≤ 3000 m<sup>2</sup>'}, condition: 'mro' },
  { label: 'Kantavat rakennusosat (600 - 1200 MJ/m<sup>2</sup>, sijainti vain 1. kerroksessa)', value: {e: 'R 90', s: 'R 60'}, p2: {default: 'R 30', ks2: 'R 90, A2'}, p3: '-', condition: 'mro' },
  { label: 'Osastoivat rakennusosat (600 - 1200 MJ/m<sup>2</sup>, sijainti vain 1. kerroksessa)', value: {e: 'EI 90', s: 'EI 60'}, p2: {default: 'EI 30', ks2: 'EI 60, A2'}, p3: 'EI 30 (myös R 30)', condition: 'mro' },
  // Jos irtainvarasto asuinkerrostalossa
  { label: 'Irtainvarasto asuinkerrostalossa (600 - 1200 MJ/m<sup>2</sup>)', isHeader: true, condition: 'iva' },
  { label: 'Palo-osasto (sijainti ullakolla)', value: 'Oma palo-osasto', p2: {default: 'Oma palo-osasto', ks2: 'Ei sallittu'}, condition: 'iva' },
  { label: 'Kantavat rakennusosat (sijainti ullakolla)', value: 'R 60', p2: {default: 'R 30', ks2: '-'}, condition: 'iva' },
  { label: 'Osastoivat rakennusosat (sijainti ullakolla)', value: 'EI 60', p2: {default: 'EI 30', ks2: '-'}, condition: 'iva' },
  { label: 'Palo-osasto (sijainti kerroksessa)', value: 'Oma palo-osasto', condition: 'iva' },
  { label: 'Kantavat rakennusosat (sijainti kerroksessa)', value: 'R 60', p2: {default: 'R 30', ks2: 'R 90'}, condition: 'iva' },
  { label: 'Osastoivat rakennusosat (sijainti kerroksessa)', value: 'EI 60', p2: {default: 'EI 30', ks2: 'EI 60'}, condition: 'iva' },
  { label: 'Palo-osasto (sijainti kellarissa)', value: 'Oma palo-osasto', condition: 'iva' },
  { label: 'Kantavat rakennusosat (sijainti kellarissa)', value: 'R 60, A2', p2: {default: 'R 60, A2', ks2: 'R 90, A2'}, condition: 'iva' },
  { label: 'Osastoivat rakennusosat (sijainti kellarissa)', value: 'R 60, A2', p2: {default: 'EI 30', ks2: 'EI 60'}, condition: 'iva' }
]

function solveSprinklaus (fireClass, userSelection) {
  if (userSelection.ktid === 5 || userSelection.ktid === 6) {
    return (userSelection.sprinklaus === 'Kyllä') ? 'Vapaaehtoinen' : 'Ei sprinklausta'
  }
  if (fireClass === 'P1' && userSelection.kerrosmaara < 3) {
    return (userSelection.sprinklaus === 'Kyllä') ? 'Vapaaehtoinen' : 'Ei sprinklausta'
  }
  return kerrosTaiKorkeus(userSelection) ? 'Pakollinen' : (userSelection.sprinklaus === 'Kyllä') ? 'Vapaaehtoinen' : 'Ei sprinklausta'
}

function solvePalovaroitin (fireClass, userSelection) {
  var id = userSelection.ktid
  var hlo = userSelection.henkilomaara
  if (id === 0 && hlo <= 150) { return 'Kyllä' } // Päiväkoti
  if (id === 1 && hlo <= 250) { return 'Kyllä' } // Koulu
  if (id === 5 || id === 6) { return 'Kyllä' } // Pientalo, Rivitalo
  if (id === 9 && hlo <= 50) { return 'Kyllä' } // Hotelli
  if (id === 10 && hlo <= 25) { return 'Kyllä' } // Palvelutalo
  return '-'
}
function solvePaloilmoitin (fireClass, userSelection) {
  var id = userSelection.ktid
  var hlo = userSelection.henkilomaara
  if (id === 0 && hlo > 150) { return 'Kyllä' } // Päiväkoti
  if (id === 1 && hlo > 250 && hlo <= 500) { return 'Kyllä' } // Koulu
  return '-'
}

function solveHKPaloilmoitin (fireClass, userSelection) {
  var id = userSelection.ktid
  var hlo = userSelection.henkilomaara
  if (id === 1 && hlo > 500) { return 'Kyllä' } // Koulu
  if (id === 9 && hlo > 50) { return 'Kyllä' } // Hotelli
  if (id === 10 && hlo > 25) { return 'Kyllä' } // Palvelutalo
  return '-'
}

function solvePalosastoJako (fireClass, userSelection) {
  var id = userSelection.ktid
  if (id === 9 || id === 10) { return 'Majoitushuoneittain' } // Hotelli & Palvelutalo
  return '-'
}

function solvePinnatKerroksessa (fireClass, userSelection) {
  var id = userSelection.ktid
  var tilat = userSelection.tilat

  // P3
  if (fireClass === 'P3' && id === 3) {
    if (tilat <= 300) { return 'D-s2, d2' }
    if (tilat > 300) { return userSelection.sprinklaus === 'Kyllä' ? 'C-s2, d1' : 'B-s1, d0' }
  }
  if (fireClass === 'P3' && id === 4) {
    return userSelection.sprinklaus === 'Kyllä' ? 'C-s2, d1' : 'B-s1, d0'
  }
  if (fireClass === 'P3' && (id === 5 || id === 6 || id === 8)) {
    return 'D-s2, d2  (ks. viite 4)'
  }

  // P2
  if (fireClass === 'P2') {
    if (id === 3) { // Myymälä
      return userSelection.sprinklaus === 'Kyllä' ? 'C-s2, d1 Kun suojaverhous, niin B-s1, d0' : 'B-s1, d0'
    }
    if (id === 4) { // Kirjasto
      return userSelection.sprinklaus === 'Kyllä' ? 'C-s2, d1 Kun suojaverhous, niin B-s1, d0' : 'B-s1, d0'
    }
    if (id === 8) { // Toimisto
      return userSelection.sprinklaus === 'Kyllä' ? 'D-s2, d2 Kun suojaverhous, niin B-s1, d0' : 'B-s1, d0 (<a href="#viitteet">ks. viite 5</a>)'
    }
    if (id === 9) { // Hotelli
      return userSelection.sprinklaus === 'Kyllä' ? 'C-s2, d1 (<a href="#viitteet">ks. viite 5</a>) Kun suojaverhous, niin B-s1, d0' : 'B-s1, d0 (<a href="#viitteet">ks. viite 5</a>)'
    }
    if (id === 10) { // Palvelutalo
      return 'B-s1, d0 Kun suojaverhous, niin B-s1, d0'
    }

    if (kerrosTaiKorkeus(userSelection)) {
      return 'D-s2, d2 Kun suojaverhous, niin A2-s1, d0'
    }
    if (tilat <= 300) {
      return 'D-s2, d2 Kun suojaverhous, niin B-s1, d0'
    } else {
      return userSelection.sprinklaus === 'Kyllä' ? 'D-s2, d2 Kun suojaverhous, niin B-s1, d0' : 'C-s2, d1 Kun suojaverhous, niin B-s1, d0'
    }
  }

  // P1
  if (fireClass === 'P1') {
    if (id === 7 || id === 8) { return 'D-s2, d2 (<a href="#viitteet">ks. viite 4</a>)' } // Asuinkerrostalo tai Toimisto
    if (id === 4 || id === 9) { // Kirjasto tai Hotelli
      return userSelection.sprinklaus === 'Kyllä' ? 'C-s2, d1' : 'B-s1, d0'
    }
    if (id === 10) { // Palvelutalo
      return 'B-s1, d0'
    }
    if (tilat > 300) {
      if (id === 3) { // Myymälä
        return userSelection.sprinklaus === 'Kyllä' ? 'C-s2, d1' : 'B-s1, d0'
      }
      return userSelection.sprinklaus === 'Kyllä' ? 'D-s2, d2' : 'C-s2, d1'
    }
  }

  return 'D-s2, d2'
}

function solveUlkoverhous (fireClass, userSelection) {
  if (fireClass === 'P2' && kerrosTaiKorkeus(userSelection)) { return 'B-s2, d0<br/> (D-s2, d2 mahdollinen <a href="#ehdot-a">ks. ehdot A</a>)' }
  if (fireClass === 'P2' && userSelection.ktid === 10) {
    if (userSelection.kerrosmaara > 2) { return 'B-s2, d0' }
    if (userSelection.sprinklaus === 'Kyllä') { return 'D-s2, d2<br/>(<a href="#ehdot-d">ks. ehdot D</a>)' }
    return 'B-s2, d0<br/>(D-s2, d2 mahdollinen <a href="#ehdot-d">ks. ehdot D</a>)'
  }
  if (fireClass === 'P1' && (userSelection.ktid === 7 || userSelection.ktid === 8)) { return 'B-s2, d0<br/>(D-s2, d2 mahdollinen <a href="#ehdot-c">ks. ehdot C</a>)' }
  if (fireClass === 'P1') { return 'B-s1, d0<br/>(D-s2, d2 mahdollinen <a href="#ehdot-b">ks. ehdot B</a>)' }
  return 'D-s2, d2'
}

function solveTuulensuoja (fireClass, userSelection) {
  if (fireClass === 'P2') {
    if (kerrosTaiKorkeus(userSelection)) {
      if (userSelection.ktid === 5 || userSelection.ktid === 6) {
        return 'B-s1, d0'
      }
      return 'A2-s1, d0'
    }
    if (userSelection.ktid === 10) {
      return 'B-s1, d0'
    }
    return 'D-s2, d2'
  }
  if (fireClass === 'P1') {
    return 'B-s1, d0'
  }

  return '-'
}

function solveKantavanRungonRakennustarvikkeet (fireClass, userSelection) {
  if (userSelection.myymalaosana === 'Kyllä') {
    return 'D-s2, d2  (ks. ehdot G)'
  }
  return 'D-s2, d2'
}

function kerrosTaiKorkeus (userSelection) {
  if (userSelection.kerrosmaara === 2 && userSelection.korkeus > 9) {
    return true
  }
  return userSelection.kerrosmaara > 2
}

function solveLabel (label, userSelection) {
  if (userSelection.ktid === 5 || userSelection.ktid === 6 || userSelection.ktid === 7 || (userSelection.ktid === 8 && userSelection.tilat < 300)) {
    if (label === 'Seinäpinnat ja seinämäiset pinnat parvekkeissa') {
      return 'Seinäpinnat ja seinämäiset pinnat varatieparvekkeissa'
    }
    if (label === 'Kattopinnat (parvekelaattojen alapinnat) parvekkeissa') {
      return 'Kattopinnat (parvekelaattojen alapinnat) varatieparvekkeissa'
    }
    if (label === 'Pilarit parvekkeissa') {
      return 'Pilarit varatieparvekkeissa'
    }
    if (label === 'Palkit parvekkeissa') {
      return 'Palkit varatieparvekkeissa'
    }
    if (label === 'Lattiapinnat parvekkeissa') {
      return 'Lattiapinnat varatieparvekkeissa'
    }
  }
  return label
}

function solvePinnat (fireClass, userSelection, label) {
  if (fireClass === 'P2') {
    if (label === 'Seinäpinnat ja seinämäiset pinnat parvekkeissa') {
      if (userSelection.ktid === 7 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9)) {
        return 'Ulkoverhouksen ulkopinnan mukaan<br/>(kaiteen ulkopinta B-s2, d0)'
      }
      if (userSelection.ktid === 8 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9) && userSelection.tilat < 300) {
        return 'Ulkoverhouksen ulkopinnan mukaan<br/>(kaiteen ulkopinta B-s2, d0)'
      }
    }
    if (label === 'Kattopinnat (parvekelaattojen alapinnat) parvekkeissa') {
      if ((userSelection.ktid === 5 || userSelection.ktid === 6 || userSelection.ktid === 9)) {
        if (userSelection.kerrosmaara === 2 || userSelection.korkeus <= 9) {
          return 'Ulkoverhouksen ulkopinnan mukaan<br/>(alimman parvekelaatan alapinta D-s2, d2)'
        }
        return 'Ulkoverhouksen ulkopinnan mukaan'
      }
      if (userSelection.ktid === 7 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9)) {
        return 'B-s2, d0'
      }
      if (userSelection.ktid === 8 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9) && userSelection.tilat < 300) {
        return 'B-s2, d0'
      }
    }
    if (label === 'Pilarit parvekkeissa') {
      if (userSelection.ktid === 7 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9)) {
        return 'D-s2, d2'
      }
      if (userSelection.ktid === 8 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9) && userSelection.tilat < 300) {
        return 'D-s2, d2'
      }
    }
    if (label === 'Palkit parvekkeissa') {
      if (userSelection.ktid === 7 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9)) {
        return 'B-s2, d0'
      }
      if (userSelection.ktid === 8 && (userSelection.kerrosmaara > 2 || userSelection.korkeus > 9) && userSelection.tilat < 300) {
        return 'B-s2, d0'
      }
    }
  }

  if (fireClass === 'P3') {
    return 'D-s2, d2'
  }
  if (label === 'Kattopinnat (parvekelaattojen alapinnat) parvekkeissa') {
    return 'Ulkoverhouksen ulkopinnan mukaan (alimman parvekelaatan alapinta D-s2, d2)'
  }
  return 'Ulkoverhouksen ulkopinnan mukaan'
}

function filterTable (fireClass, userSelection) {
  let items = []
  let s = false
  let floors = null
  let runko = null
  let id = 0

  if (userSelection !== null) {
    s = userSelection.sprinklaus !== 'Ei'
    floors = userSelection.kerrosmaara
    id = userSelection.ktid

    // implement this
    if (fireClass === 'P1' && userSelection.results.p1 !== null) { runko = userSelection.results.p1.runko }
    if (fireClass === 'P2' && userSelection.results.p2 !== null) { runko = userSelection.results.p2.runko }
    if (fireClass === 'P3' && userSelection.results.p3 !== null) { runko = userSelection.results.p3.runko }
  }

  maarayksetRows.forEach(
    function (element) {
      // Dynamic labels
      let label = element.label
      if (element.isDynamic) {
        label = solveLabel(element.label, userSelection)
      }
      let item = {label: label, isHeader: element.isHeader}
      item.value = element.value

      // If fireclass based results
      if (fireClass === 'P1' && element.p1) {
        item.value = element.p1
      }
      if (fireClass === 'P2' && element.p2) {
        item.value = element.p2
      }
      if (fireClass === 'P3' && element.p3) {
        item.value = element.p3
      }

      // Id based exceptions
      if (item.value && item.value.idvalue) {
        if (item.value.ids.indexOf(id) >= 0) {
          item.value = item.value.idvalue
        } else if (item.value.default) {
          item.value = item.value.default
        }
      }

      // Runko based results
      if (item.value && item.value.r30) { item.value = runko === 'R 30' ? item.value.r30 : item.value.default }
      if (item.value && item.value.r45) { item.value = runko === 'R 45' ? item.value.r45 : item.value.default }
      if (item.value && item.value.r90) { item.value = runko === 'R 90' ? item.value.r90 : item.value.default }

      // Floor amount based results
      if (item.value && item.value.k1) {
        item.value = floors === 1 ? item.value.k1 : '-'
      }
      if (item.value && item.value.ks3) {
        if ((id === 5 || id === 6) && floors < 5) {
          item.value = kerrosTaiKorkeus(userSelection) ? item.value.ks3 : item.value.default
        }
        if (id === 7) {
          if (userSelection.korkeus > 14 && item.value.ks2) {
            item.value = item.value.ks2
          } else {
            item.value = kerrosTaiKorkeus(userSelection) ? item.value.ks3 : item.value.default
          }
        }
      }
      if (item.value && item.value.ks2) {
        item.value = kerrosTaiKorkeus(userSelection) ? item.value.ks2 : item.value.default
      }

      // Sprinkler value based results
      if (item.value) {
        if (item.value.s && s) { item.value = item.value.s }
        if (item.value.e && !s) { item.value = item.value.e }
      }

      // Replace with variables
      if (item.value && item.value.v && item.value.rs) {
        if (item.value.v === 'runko') { item.value = item.value.rs.replace('X', runko) };
      }

      // Call solver functions
      if (userSelection !== null) {
        if (element.func === 'solveSprinklaus') { item.value = solveSprinklaus(fireClass, userSelection) }
        if (element.func === 'solvePalovaroitin') { item.value = solvePalovaroitin(fireClass, userSelection) }
        if (element.func === 'solvePaloilmoitin') { item.value = solvePaloilmoitin(fireClass, userSelection) }
        if (element.func === 'solveHKPaloilmoitin') { item.value = solveHKPaloilmoitin(fireClass, userSelection) }
        if (element.func === 'solvePalosastoJako') { item.value = solvePalosastoJako(fireClass, userSelection) }
        if (element.func === 'solvePinnatKerroksessa') { item.value = solvePinnatKerroksessa(fireClass, userSelection) }
        if (element.func === 'solveUlkoverhous') { item.value = solveUlkoverhous(fireClass, userSelection) }
        if (element.func === 'solveTuulensuoja') { item.value = solveTuulensuoja(fireClass, userSelection) }
        if (element.func === 'solveKantavanRungonRakennustarvikkeet') { item.value = solveKantavanRungonRakennustarvikkeet(fireClass, userSelection) }
        if (element.func === 'solvePinnat') { item.value = solvePinnat(fireClass, userSelection, element.label) }
      }

      if (element.condition) {
        if (
          (element.condition === 'aro' && userSelection.autosuojaosana === 'Kyllä') ||
          (element.condition === 'mro' && userSelection.myymalaosana === 'Kyllä') ||
          (element.condition === 'iva' && userSelection.irtainvarastoja === 'Kyllä')
        ) {
          items.push(item)
        }
      } else {
        items.push(item)
      }
    }
  )
  return items
}

export default filterTable



// WEBPACK FOOTER //
// ./src/data/palomaaraykset.js